/**
 * Pure reconciliation logic for D1 pull.
 * Computes which local IDs are stale (exist locally but not in the remote set).
 * Ad-hoc queries (systemPreset) are local-only and always preserved.
 */

interface LocalQueryInfo {
  id: string;
  serverId: string;
  systemPreset?: string;
}

export function computeStaleQueryIds(
  localQueries: LocalQueryInfo[],
  remoteQueryIds: Set<string>,
): string[] {
  return localQueries
    .filter((q) => !q.systemPreset && !remoteQueryIds.has(q.id))
    .map((q) => q.id);
}

export function computeStaleServerIds(
  localServerIds: string[],
  remoteServerIds: Set<string>,
): string[] {
  return localServerIds.filter((id) => !remoteServerIds.has(id));
}

export function computeStaleVaultEntryIds(
  localEntryIds: string[],
  remoteEntryIds: Set<string>,
): string[] {
  return localEntryIds.filter((id) => !remoteEntryIds.has(id));
}
